/** `/settings/email`: the platform's sending settings, brand and e-mail templates. A customer whose tier allows its own e-mail sets its own on its page. */

import { useTranslation } from 'react-i18next';
import { PageHeader, useDocumentTitle } from '../../components/PageHeader';
import { EmailSettingsPanel } from './EmailSettingsPanel';
import { TemplatesPanel } from './TemplatesPanel';

export function EmailPage() {
  const { t } = useTranslation('integrations');
  useDocumentTitle(t('email.pageTitle'));
  return (
    <>
      <PageHeader title={t('email.pageTitle')} subtitle={t('email.pageSubtitle')} crumbs={[{ label: t('email.crumb') }]} />
      <div className="grid gap-6">
        <EmailSettingsPanel owner="platform" />
        <TemplatesPanel owner="platform" />
      </div>
    </>
  );
}
